import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet';

import { AiCopilotDrawer } from '../../../components/ai-copilot/AiCopilotDrawer';
import { AiCopilotProvider } from '../../../components/ai-copilot/context/AiCopilotProvider';
import { useAiCopilot } from '../../../components/ai-copilot/context/use-ai-copilot';
import { VyLayout } from '../../../components/new-design/layout/VyLayout';
import { withGlobalSearchParams } from '../../../components/utility/GlobalSearchParamsBoundary';
import { withSuspenseBoundary } from '../../../components/utility/SuspenseBoundary';
import { USAGE_DATA_REPORT_CONTEXT, USAGE_DATA_REPORT_SUGGESTIONS } from '../usage-data-report-suggestions';
import { CommitmentVsUsageReportContent } from './commitment-vs-usage-report-components/CommitmentVsUsageReportContent';

const CommitmentVsUsageReportLayout: React.FC = () => {
  const { isOpen, drawerWidth } = useAiCopilot();

  return (
    <>
      <Box
        sx={{
          transition: (theme) =>
            theme.transitions.create('margin-right', {
              easing: isOpen
                ? theme.transitions.easing.easeOut
                : theme.transitions.easing.sharp,
              duration: isOpen
                ? theme.transitions.duration.enteringScreen
                : theme.transitions.duration.leavingScreen,
            }),
          marginRight: isOpen ? `${drawerWidth}px` : 0,
        }}
      >
        <VyLayout>
          <CommitmentVsUsageReportContent />
        </VyLayout>
      </Box>
      <AiCopilotDrawer />
    </>
  );
};

const CommitmentVsUsageReportPage: React.FC = () => {
  return (
    <AiCopilotProvider suggestions={USAGE_DATA_REPORT_SUGGESTIONS} reportContext={USAGE_DATA_REPORT_CONTEXT}>
      <Helmet>
        <title>Commitment vs Usage</title>
      </Helmet>
      <CommitmentVsUsageReportLayout />
    </AiCopilotProvider>
  );
};

const CommitmentVsUsageReportPageWithSuspenseBoundary = withSuspenseBoundary(
  withGlobalSearchParams(CommitmentVsUsageReportPage),
);

export { CommitmentVsUsageReportPageWithSuspenseBoundary as CommitmentVsUsageReportPage };
